import React from "react";
import { Link } from "react-router-dom";
import { getJSON } from "../utils/cart";

export default function OrderConfirmation() {
  const order = getJSON("lastOrder", null);

  if (!order) {
    return (
      <div className="container pagePadBottom">
        <div className="card emptyCard">
          <div className="h2">No order found</div>
          <div className="muted" style={{ marginTop: 6 }}>
            Place an order first, then come back here.
          </div>
          <div className="row" style={{ marginTop: 12 }}>
            <Link className="btnPrimary" to="/categories">
              Browse items
            </Link>
          </div>
        </div>
      </div>
    );
  }

  const created = order.createdAt
    ? new Date(order.createdAt).toLocaleString()
    : "";

  return (
    <div className="container pagePadBottom orderPage">
      <div className="card">
        <div className="orderHero">
          <div>
            <div className="h2">Order Confirmed </div>
            <div className="muted small" style={{ marginTop: 6 }}>
              Order #{order.orderId} {created ? `• ${created}` : ""}
            </div>
          </div>

          <div className="pill">
            Total{" "}
            <span className="pillStrong">
              ${Number(order.total || 0).toFixed(2)}
            </span>
          </div>
        </div>

        <div className="divider" />

        <div className="cardTitle">Items</div>
        <div className="summaryList" style={{ marginTop: 10 }}>
          {(order.items || []).map((it, idx) => (
            <div key={idx} className="summaryRow">
              <div className="summaryLeft">
                <div className="summaryName">{it.product_name}</div>
                <div className="muted small">Qty {it.quantity}</div>
              </div>
              <div className="summaryValue">
                ${(Number(it.price || 0) * Number(it.quantity || 0)).toFixed(2)}
              </div>
            </div>
          ))}
        </div>

        <div className="divider" />

        <div className="summaryRow">
          <div className="muted">Subtotal</div>
          <div className="summaryValue">
            ${Number(order.subtotal || 0).toFixed(2)}
          </div>
        </div>

        <div className="summaryRow" style={{ marginTop: 8 }}>
          <div className="muted">Shipping</div>
          <div className="summaryValue">
            ${Number(order.shipping || 0).toFixed(2)}
          </div>
        </div>

        <div className="summaryRow" style={{ marginTop: 8 }}>
          <div className="muted">Discount</div>
          <div className="summaryValue">
            - ${Number(order.discount || 0).toFixed(2)}
          </div>
        </div>

        <div className="summaryRow" style={{ marginTop: 10 }}>
          <div className="summaryTotalLabel">Total</div>
          <div className="priceBlue">
            ${Number(order.total || 0).toFixed(2)}
          </div>
        </div>

        {order.promo?.code ? (
          <div className="notice" style={{ marginTop: 14 }}>
            <div style={{ fontWeight: 900 }}>Promo Applied</div>
            <div className="muted" style={{ marginTop: 6 }}>
              {order.promo.code}
            </div>
          </div>
        ) : null}

        <div
          className="row"
          style={{ marginTop: 14, gap: 10, flexWrap: "wrap" }}
        >
          <Link className="btnSecondary" to="/categories">
            Continue browsing
          </Link>
          <Link className="btnPrimary" to="/">
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}
